import { useEffect, useState } from 'react';
import { Alert, Box, Grid, Typography } from '@mui/material';
import { Tag } from '../models/tag';
import Meal, { mapMealFromApi } from '../models/meal';
import { getTagsByGroup } from '../api/tag-api';
import { callApiWithData } from '../api/call-api';
import ChoiceCard from '../components/ChoiceCard/ChoiceCard';
import MealItem from '../components/Meal/MealItem';
import Loader from '../components/UI/General/Loader';

const CookingGuidanceByCuisine = () => {
  const [cuisines, setCuisines] = useState<Tag[]>([]);
  const [selectedCuisine, setSelectedCuisine] = useState<Tag | null>(null);
  const [meals, setMeals] = useState<Meal[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getTagsByGroup().then((groups) => setCuisines(groups.cuisine));
  }, []);

  const handleSelect = async (cuisine: Tag) => {
    setSelectedCuisine(cuisine);
    setLoading(true);
    setError(null);
    try {
      const response = await callApiWithData('/chef-meals', { tags: { cuisine: [cuisine.id] } }, 'POST');
      setMeals(response.meals.map(mapMealFromApi));
    } catch {
      setError('Nepodařilo se načíst recepty.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Podle kuchyně
      </Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {cuisines.map((cuisine) => (
          <Grid item xs={4} md={3} key={cuisine.id}>
            <ChoiceCard icon={null} title={cuisine.name} variant="small" onClick={() => handleSelect(cuisine)} />
          </Grid>
        ))}
      </Grid>

      {selectedCuisine && (
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {selectedCuisine.name} kuchyně
        </Typography>
      )}

      {loading && <Loader />}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && selectedCuisine && meals.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          Žádné recepty pro tuto kuchyni.
        </Typography>
      )}

      {!loading && !error && meals.length > 0 && (
        <Grid container spacing={{ xs: 2, md: 4 }}>
          {meals.map((meal) => (
            <Grid key={meal.id} item xs={12} md={6}>
              <MealItem meal={meal} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default CookingGuidanceByCuisine;
